import React, { useContext } from 'react';
import { useForm } from "react-hook-form";
import styles from './CheckoutForm.module.scss';
import getStripe from "../../../utils/stripejs";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../../context/GlobalContextProvider";
import FormBreadCrumbs from '../../generic/FormBreadCrumbs/FormBreadCrumbs';
import { AnimatePresence, AnimateSharedLayout } from 'framer-motion';
import DataInnerForm from '../DataInnerForm/DataInnerForm';
import PregnantInnerForm from '../PregnantInnerForm/PregnantInnerForm';
import SummaryInnerForm from '../SummaryInnerForm/SummaryInnerForm';

const CheckoutForm  = ({
  lesson,
  babyConnect,
  checkoutSection,
  setCheckoutSection
}) => {
  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext)
  const { control, errors, handleSubmit } = useForm();

  const redirectToCheckout = async (string, data) => {
    if (string === 'PAYMENT') {
      const stripe = await getStripe();

      const response = await fetch('/api/checkout', {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            formData: state.data,
            ...lesson
          },
        )
      });

      const session = await response.json();

      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      })

      if (result.error) {
        console.error(result.error);
      }
      return;
    }

    dispatch({
      type: "ADD_FORM_DATA",
      payload: data,
    });

    setCheckoutSection(string);
  }

  const sectionRenderer = (babyConnect) => {
    switch (checkoutSection) {
      case "GEGEVENS":
        return (
          <DataInnerForm
            state={state}
            control={control}
            errors={errors}
            onClick={
              handleSubmit((data) => redirectToCheckout('ZWANGERSCHAP', data))
            }
          />
        );
      case "ZWANGERSCHAP":
        return (
          <PregnantInnerForm
            babyConnect={babyConnect}
            state={state}
            control={control}
            errors={errors}
            setCheckoutSection={() => setCheckoutSection('GEGEVENS')}
            onClick={handleSubmit((data) => redirectToCheckout('CHECKOUT', data))}
          />
        );
      case "CHECKOUT":
        return (
          <SummaryInnerForm
            babyConnect={babyConnect}
            setCheckoutSection={() => setCheckoutSection('ZWANGERSCHAP')}
            onClick={() => redirectToCheckout('PAYMENT')}
            state={state}
          />
        )
      default:
        return null;
    }
  }

  return (
    <AnimatePresence>
      <AnimateSharedLayout>
        <div className={styles.modal}>
          <FormBreadCrumbs section={checkoutSection} />
          {sectionRenderer(babyConnect)}
        </div>
      </AnimateSharedLayout>
    </AnimatePresence>
  )
}

export default CheckoutForm;